import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Mountain, Home } from 'lucide-react';
import { Page } from '@/components/layout/Page';
import { PageContent } from '@/components/layout/PageContent';

export function NotFoundPage() {
    const { t } = useTranslation();

    return (
        <Page className="bg-slate-50">
            <PageContent width="narrow" className="flex flex-col items-center justify-center min-h-[80vh] text-center">
                <div className="w-24 h-24 bg-slate-100 rounded-3xl flex items-center justify-center mb-6">
                    <Mountain size={48} className="text-slate-300" />
                </div>

                <h1 className="text-6xl font-black text-slate-200 mb-2">404</h1>
                <h2 className="text-xl font-bold text-slate-900 mb-2">{t('errorPage.notFound.title')}</h2>
                <p className="text-slate-500 mb-8 max-w-sm">{t('errorPage.notFound.message')}</p>

                <Link
                    to="/"
                    className="bg-emerald-600 text-white px-6 py-3 rounded-2xl font-bold flex items-center gap-2 hover:bg-emerald-700 transition-all shadow-lg shadow-emerald-200"
                >
                    <Home size={18} />
                    {t('errorPage.backHome')}
                </Link>
            </PageContent>
        </Page>
    );
}
